// Reasoning effort ("thinking mode", plan 101 slice 17) — the ONE vocabulary.
//
// A purpose route stores it (`llm_routes.reasoning_effort`), the resolved pick and
// the fleet assignment carry it, and each harness hands it to `reasoningOptions`
// (`@developerz/agent`), which maps it onto the provider's own knob or REFUSES the
// pairing. It lives here because the mothership and the box both key on it, and
// neither may import the other.
//
// Five levels, lowest first. There is deliberately no `none` / `minimal` / `off`:
// "no thinking requested" is an ABSENT effort, and an absent effort sends
// byte-identical requests to the pre-slice-17 ones. A sixth level meaning "off"
// would be a second spelling of absent — and one some providers reject outright.
// No level maps to a token BUDGET either: a model whose only control is a budget is
// refused by `reasoningOptions` (`docs/standards/agent-budgets.md`).

import { z } from 'zod';

/** Every effort level, lowest first. A stored value outside it is refused at read. */
export const REASONING_EFFORTS = ['low', 'medium', 'high', 'xhigh', 'max'] as const;

export const ReasoningEffortSchema = z.enum(REASONING_EFFORTS);
export type ReasoningEffort = z.infer<typeof ReasoningEffortSchema>;
